import { render, staticRenderFns } from "./TopPicksNew.vue?vue&type=template&id=0c7414e4&scoped=true"
import script from "./TopPicksNew.vue?vue&type=script&lang=js"
export * from "./TopPicksNew.vue?vue&type=script&lang=js"
import style0 from "./TopPicksNew.vue?vue&type=style&index=0&id=0c7414e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7414e4",
  null
  
)

export default component.exports